/**
 * @license Copyright (c) 2022, Memo.ph by Globe Telecom. All rights reserved.
 */
import React from 'react';
import Container from '../container/Container';
import Subtitle from '../typography/Subtitle';
import Title from '../typography/Title';

const Error404 = () => {
    return (
        <Container>
            <Title>Not Found</Title>
            <Subtitle>Error 404. Page not found.</Subtitle>
        </Container>
    );
};

export default Error404;
